// extracted by mini-css-extract-plugin
module.exports = {"badge":"_315781c"};